export const setPageTitle = (title: string) => {
  const titleEl = document.querySelector("title")
  if (titleEl) {
    titleEl.innerHTML = title
  }
}
